import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../../../service/seo.service';

@Component({
    selector: 'app-mezzogiorno-aree-agevolate',
    templateUrl: './mezzogiorno-aree-agevolate.component.html',
    standalone: false
})
export class MezzogiornoAreeAgevolateComponent implements OnInit {

    constructor(private router: Router, private seoService: SeoService) { }

    ngOnInit(): void {
        const h2Text = "Agevolazioni Sud: contributi e crediti d’imposta potenziati per imprese al Mezzogiorno. Incentivi ZES, sostegno PNRR e Politiche di Coesione";
        
        this.seoService.updateSeo({
            titleSeo: "Bandi Mezzogiorno & Aree Agevolate – PMI | Innovation Plaza",
            metadescription: h2Text
        });
    }

    goTo(route: string){		 
        this.router.navigate([route])
    }

}